const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Stripe = () => import(/* webpackChunkName: "stripe" */ './view/edit.vue');

export const ROUTE_NAME_STRIPE = 'Stripe' as const;

export default [
    {
        path: '/app/:appId/stripe',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_STRIPE,
                component: Stripe,
                meta: { requiresAuth: true }
            }
        ]
    }
];
